var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product_inf"},[_c('card',{attrs:{"title":"品质承诺"}},[_c('div',{staticClass:"product_inf_content",staticStyle:{"padding":"0rem 2rem 0.6rem 1.8rem"}},[_c('span',{staticClass:"inlineblock width100 yellowfont minfont widthStyle",domProps:{"innerHTML":_vm._s(_vm.commitmentToQuality)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }